import { ShieldOff } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import UserDropdown from "@/components/UserDropdown";

export default function NotEnabledPage() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="flex items-center justify-end px-4 h-14 border-b shrink-0">
        <UserDropdown />
      </header>

      <div className="flex-1 flex items-center justify-center p-6">
        <Card className="max-w-md w-full border bg-background">
          <CardHeader className="text-center space-y-4">
            <div className="flex justify-center">
              <div className="p-4 bg-muted rounded-full">
                <ShieldOff className="h-12 w-12 text-muted-foreground" />
              </div>
            </div>
            <CardTitle className="text-2xl font-semibold text-primary">
              Kein Zugang
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div className="text-center space-y-3">
              <p className="text-sm text-muted-foreground">
                Für Ihr Konto wurde noch keine Lizenz vergeben.
              </p>
              <p className="text-sm text-muted-foreground">
                Bitte wenden Sie sich an Ihren lytra-Ansprechpartner, um eine
                Lizenz zu erhalten.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
